import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { theme } from './theme'
import LandingPage from './pages/LandingPage'
import NotFoundPage from './pages/NotFoundPage'
import AboutUs from './pages/AboutUs'
import Solution from './pages/Solution'
import ProductPage from './pages/ProductPage'
import ResourcesPage from './pages/ResourcesPage'
import CaseStudiesPage from './pages/CaseStudiesPage'
import WhitePapersPage from './pages/WhitePapersPage'
import CaseStudyPage from './pages/CaseStudyPage'
import WhitePaperPage from './pages/WhitePaperPage'
import Header from './components/Header'
import './App.css'

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const shouldHideHeader = false

  return (
    <div className="app-container">
      <ScrollToTop />
      {!shouldHideHeader && <Header />}
      <main className="app-main">
        <div
          className="app-main-inner"
          style={
            !shouldHideHeader
              ? { paddingTop: 'var(--header-height)', minHeight: '100%' }
              : { minHeight: '100%' }
          }
        >
          <Routes>
            {/* Public marketing and content surface */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/solution" element={<Solution />} />
            <Route path="/how-it-works" element={<ProductPage />} />
            <Route path="/product" element={<Navigate to="/how-it-works" replace />} />
            {/* Nav labels say Platform / Solutions / Insights — accept the
                guessable URLs instead of silently serving the homepage. */}
            <Route path="/platform" element={<Navigate to="/how-it-works" replace />} />
            <Route path="/solutions" element={<Navigate to="/solution" replace />} />
            <Route path="/insights" element={<Navigate to="/resources" replace />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/learn-more" element={<Navigate to="/resources" replace />} />
            <Route path="/request-demo" element={<Navigate to="/" replace />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/case-studies/:slug" element={<CaseStudyPage />} />
            <Route path="/white-papers" element={<WhitePapersPage />} />
            <Route path="/white-papers/:slug" element={<WhitePaperPage />} />
            <Route path="/resources/:slug" element={<WhitePaperPage />} />

            {/* Legacy pages intentionally hidden from the public site. */}
            <Route path="/the-problem" element={<Navigate to="/" replace />} />
            <Route path="/results" element={<Navigate to="/" replace />} />
            <Route path="/compare" element={<Navigate to="/" replace />} />
            <Route path="/demos" element={<Navigate to="/" replace />} />
            <Route path="/guided-demo" element={<Navigate to="/" replace />} />
            <Route path="/guided-checkout-demo" element={<Navigate to="/" replace />} />
            <Route path="/investors" element={<Navigate to="/" replace />} />
            <Route path="/api-demo" element={<Navigate to="/" replace />} />
            <Route path="/org-insights-demo" element={<Navigate to="/" replace />} />
            <Route path="/portal" element={<Navigate to="/" replace />} />
            <Route path="/portal/app" element={<Navigate to="/" replace />} />
            <Route path="/portal/app/*" element={<Navigate to="/" replace />} />
            <Route path="/payment-optimization" element={<Navigate to="/" replace />} />
            {/* Unknown URLs get a real 404, not a silent homepage. */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App
